




























import { Component, Prop, Vue } from "@/shared/vuepack";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import * as Routes from "@/employee/route-names";
import CurrentHoldingsTable from "@/shared/components/investments/drivewealth/CurrentHoldingsTable.vue";
import CurrentHoldingsTableV2 from "@/shared/components/investments/drivewealth/CurrentHoldingsTableV2.vue";
import CurrentHoldingsSummaryPanel from "@/shared/components/investments/drivewealth/CurrentHoldingsSummaryPanel.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import { DrivewealthAccountManagementType } from "@/shared/types";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    DrivewealthNavigation,
    CurrentHoldingsTable,
    CurrentHoldingsTableV2,
    GenericLoadingSpinner,
    AccountTypeSubheader,
    CurrentHoldingsSummaryPanel
  }
})
export default class CurrentHoldings extends Vue {
  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: true })
  accountId: number;

  @Prop({ required: true })
  pageNumber: number;

  drivewealthStore = useDrivewealthStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  featureFlagStore = useFeatureFlagStore();

  Routes = Routes;

  get isLoaded (): boolean {
    return this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }

  get displayRetakeRtqButton (): boolean {
    const account = this.drivewealthStore.accountSummaryById(this.accountId);

    return account.accountManagementType === DrivewealthAccountManagementType.RiaManaged;
  }

  get useCurrentHoldingsV2 (): boolean {
    return this.featureFlagStore.flags.bend29688UseCurrentHoldingsTableV2;
  }
}
